import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate'
})
export class TruncatePipe implements PipeTransform {
  transform(value: string, maxLength: number = 25, tail: string = '...'): string {
    if (!value) return '';
    return value.length > maxLength ? value.slice(0, maxLength - tail.length) + tail : value;
  }
}
